import React, { Component } from "react"
import { Avatar, Button, Divider, Input } from "antd"

import commentChorri from "../../images/comments-images/Chorri.svg"
import commentEllipse from "../../images/comments-images/Ellipse.svg"
import commentStarts from "../../images/comments-images/Estrellas.svg"
import commentGroup from "../../images/comments-images/Group.svg"
import commentNubes from "../../images/comments-images/Nubes.svg"
import { getComments, createComment } from "./api"
import { LOCAL_USER_PHOTO } from "../../utils/storage"

const { TextArea } = Input

class EmptyStateComments extends Component {
  state = { comment: "" }

  render() {
    const { comment } = this.state
    const { initialData } = this.props
    const sharedData = {
      id_measure: initialData && initialData.id_measure,
      id_division: initialData && initialData.id_division,
      id_dimension: initialData && initialData.id_dimension,
    }

    return (
      <div className="container-actionplan__plans-empty">
        <div className="container-actionplan__comment-empty">
          <img src={commentNubes} alt="comment-nubes" />
          <img src={commentStarts} alt="comment-starts" />
          <img src={commentGroup} alt="comment-group" />
          <img src={commentEllipse} alt="comment-ellipse" />
          <img src={commentChorri} alt="comment-chorri" />
          {/* <img src={emptyStateActionPlans} alt='actions-plans'/> */}
        </div>
        <p>
          Aún no cuentas con <strong>comentarios</strong> para esta dimensión.
        </p>
        <div className="container-actionplan__plans-empty-border">
          En esta sección podrás hacer y recibir
          <strong> comentarios</strong> con el resto de embajadores de la
          división y usuarios administradores del sistema.
        </div>
        <div style={{ width: "100%", padding: "0 24px" }}>
          <Divider />
        </div>
        <div
          className="container-actionplan__add-comment"
          style={{ width: "100%" }}>
          <Avatar size={64} src={LOCAL_USER_PHOTO()} />
          <TextArea
            rows={4}
            value={comment}
            onChange={(event) => this.setState({ comment: event.target.value })}
          />
        </div>
        <div
          className="container-actionplan__add-comment-btns"
          style={{ width: "100%" }}>
          <Button
            disabled={!comment}
            onClick={() => {
              this.setState({ comment: "" })
            }}>
            Cancelar
          </Button>
          <Button
            disabled={!comment}
            type="primary"
            onClick={async () => {
              await createComment({
                data: {
                  ...sharedData,
                  message: this.state.comment,
                },
              })
              const comments = await getComments({ params: sharedData })

              this.props.getDimensions(true)
              this.setState({ comment: "" })
              this.props.setStateFrom({ comments })
            }}>
            Comentar
          </Button>
        </div>
      </div>
    )
  }
}

export default EmptyStateComments
